import { StrikethroughPlugin } from '@udecode/plate-basic-marks/react';

const StrikePlugin = {
  ...StrikethroughPlugin,
  key: 'strike',
  node: {
    ...StrikethroughPlugin.node,
    type: 'strike',
  },
};

export { StrikePlugin };
